/**
 * Async entry point required by Module Federation.
 * The actual app bootstrap is in bootstrap.tsx — this indirection
 * ensures shared modules (react, react-dom, etc.) are resolved
 * before any application code executes.
 */
import("./bootstrap");

export {};
